module.exports = __webpack_public_path__ + "static/img/changePass.ad2c4c9.svg";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/changePass.svg
// module id = /GUC
// module chunks = 1